var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.222 19.778h1.584l10.86-10.861-1.583-1.584-10.86 10.861zM3.112 22q-.474 0-.793-.32A1.08 1.08 0 0 1 2 20.89v-2.695a2.2 2.2 0 0 1 .639-1.555l14.028-14q.333-.306.736-.472Q17.805 2 18.25 2t.861.167q.417.165.722.5l1.528 1.555q.333.306.486.722a2.4 2.4 0 0 1 0 1.681 2.1 2.1 0 0 1-.486.736l-14 14q-.306.306-.708.472Q6.25 22 5.806 22zm12.75-13.861-.779-.806 1.584 1.584z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditOutline);
export default __webpack_public_path__ + "static/media/Edit_outline.ac733595b3dc2c4229c029a76e0dae3c.svg";
export { ForwardRef as ReactComponent };